import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import LayoutManager from "../../../../../lib/html5-software-library/src/ranj/layout/LayoutManager";
import AbstractMediator from "../../../core/ui/AbstractMediator";
import ClickEaterFactory from "../../../core/ui/ClickEaterFactory";
import HubKeyDecisionListItemFactory from "../controller/HubKeyDecisionListItemFactory";

export default class HubKeyDecisionListMediator extends AbstractMediator {
    /**
     * @constructor
     * @param {createjs.MovieClip} target 
     * @param {soma.EventDispatcher} dispatcher 
     * @param {LayoutManager} layoutManager 
     * @param {ClickEaterFactory} clickEaterFactory 
     * @param {RevisableLanguagePack} languagePack 
     * @param {HubKeyDecisionListItemFactory} hubKeyDecisionListItemFactory 
     */
    constructor(target, dispatcher, layoutManager, clickEaterFactory, languagePack, hubKeyDecisionListItemFactory) {
        super(target, dispatcher, layoutManager, clickEaterFactory);

        this._languagePack = languagePack;
        this._hubKeyDecisionListItemFactory = hubKeyDecisionListItemFactory;

        /** @type {Array<HubKeyDecisionListItemMediator>} */
        this._listItems = [];
    }

    initialize() {
        super.initialize();

        this._target.removeAllChildren();
    }

    destroy() {
        super.destroy();

        for (let i = 0; i < this._listItems.length; i++) {
            const listItem = this._listItems[i];
            listItem.destroy();
        }

        this._listItems = [];
        this._target.removeAllChildren();
    }

    addKeyDecision(keyDecision) {
        const keyDecisionListItemMediator = this._hubKeyDecisionListItemFactory.createKeyDecisionListItem(this._target, keyDecision);
        this._listItems.push(keyDecisionListItemMediator);

        // Animate in the new item
        keyDecisionListItemMediator.skin.x = 100;
        keyDecisionListItemMediator.skin.y = this._getNextItemY();
        keyDecisionListItemMediator.skin.alpha = 0;

        createjs.Tween.get(keyDecisionListItemMediator.skin)
            .to({ alpha: 1, x: 0 }, 650, createjs.Ease.sineInOut);

        this.updateItemPositions();
    }

    removeKeyDecision(keyDecision) {
        const listItemToRemoveIndex = this._listItems.findIndex(i => i.keyDecision === keyDecision);
        const listItemToRemove = this._listItems[listItemToRemoveIndex];
        this._listItems.splice(listItemToRemoveIndex, 1)

        createjs.Tween.get(listItemToRemove.skin)
            .to({ alpha: 0, x: 100 }, 650, createjs.Ease.sineInOut);

        this.updateItemPositions();
    }

    updateItemPositions() {
        const totalHeight = HubKeyDecisionListMediator.ITEM_SPACING * this._listItems.length;
        let nextY = -totalHeight * .5 + HubKeyDecisionListMediator.ITEM_SPACING * .5;

        for (let i = 0; i < this._listItems.length; i++) {
            const listItem = this._listItems[i];
            createjs.Tween.get(listItem.skin)
                .to({ y: nextY }, 650, createjs.Ease.sineInOut);

            nextY += HubKeyDecisionListMediator.ITEM_SPACING;
        }
    }

    _getNextItemY() {
        const totalHeight = HubKeyDecisionListMediator.ITEM_SPACING * this._listItems.length;
        const startingY = -totalHeight * .5 + HubKeyDecisionListMediator.ITEM_SPACING * .5;

        return startingY + HubKeyDecisionListMediator.ITEM_SPACING * (this._listItems.length - 1);
    }
}

HubKeyDecisionListMediator.ITEM_SPACING = 142;